import {atom} from "jotai";

/**
 * Whether the Discovery header cart icon should show a checkout warning
 * (e.g. a line with closed registration). Hydrated from the header, then
 * updated by add/remove cart actions.
 */
export const cartHasCheckoutWarningAtom = atom(false);
